var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#DDE2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8337 9.66406V12.1641C23.8337 15.3857 21.222 17.9974 18.0003 17.9974M18.0003 17.9974C14.7787 17.9974 12.167 15.3857 12.167 12.1641V9.66406M18.0003 17.9974C21.222 17.9974 23.8337 20.6091 23.8337 23.8307V26.3307M18.0003 17.9974C14.7787 17.9974 12.167 20.6091 12.167 23.8307V26.3307",
    stroke: "#6680F4",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 9.66406H24.6663M24.6663 26.3307H11.333",
    stroke: "#6680F4",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosingSoon);
export default __webpack_public_path__ + "static/media/Closing_soon.1304b2a8c502e13fdc219c33d2ead46d.svg";
export { ForwardRef as ReactComponent };